import { apiGet, apiPost, apiPostForm } from "../../shared/api";

/** Una lettura del saldo. Gli importi sono STRINGHE: arrivano da Decimal. */
export type LetturaSaldo = {
  letto_il: string;
  stato: "ok" | "non_disponibile" | "da_collegare" | "errore";
  saldo: string | null;
  valuta: string;
  in_arrivo: string | null;
  in_arrivo_il: string | null;
  ultimo_bonifico: string | null;
  ultimo_bonifico_il: string | null;
  motivo: string;
  /** Il saldo «calcolato da noi» con la regola di pagamento del canale:
   *  accanto a quello vero, mai al suo posto e mai nel totale vero. */
  calcolato: string | null;
  calcolato_dal: string | null;
  calcolo_nota: string;
};

export type ContoSaldo = {
  chiave: string;
  nome: string;
  logo: string;
  gruppo: "marketplace" | "pagamenti";
  /** ``false``: il canale non da' il saldo a OM, vale il motivo. */
  leggibile: boolean;
  ultima: LetturaSaldo | null;
  /** L'ultimo saldo buono, solo se l'ultima lettura non lo e'. */
  ultimo_buono: LetturaSaldo | null;
  /** Il bonifico che il canale dice di aver fatto e' nell'estratto conto?
   *  ``null``: nessun estratto caricato o niente da confrontare. */
  in_banca: "arrivato" | "non_trovato" | "da_verificare" | null;
};

/** Un canale come lo vede la banca: i bonifici ricevuti. */
export type IncassoCanale = {
  chiave: string;
  nome: string;
  /** Il conto della pagina a cui si aggancia, se ne ha uno. */
  conto: string | null;
  ultimo_bonifico: string;
  ultimo_bonifico_il: string;
  mese: string;
  bonifici_mese: number;
};

export type Banca = {
  /** Quando e' stato caricato l'ultimo estratto conto. */
  caricato_il: string;
  file_nome: string;
  /** L'ultimo giorno coperto dai movimenti caricati. */
  coperto_fino: string | null;
  saldo_contabile: string | null;
  disponibile: string | null;
  fido: string | null;
  saldo_al: string | null;
  canali: IncassoCanale[];
  non_riconosciuti: { ordinante: string; bonifici: number; totale: string; ultimo_il: string }[];
  /** Note di credito fornitori, soci, rimborsi del corriere: senza nomi. */
  altre_entrate: { bonifici: number; totale: string };
};

export type Controllo = {
  tipo:
    | "fornitore_sbagliato"
    | "doppio_pagamento"
    | "fattura_pagata_due_volte"
    | "bonifico_non_arrivato";
  titolo: string;
  dettaglio: string;
  importo: string | null;
  data: string;
  stato: "da_controllare" | "risolto";
  risolto_da: string;
};

export type EsitoEstratto = {
  righe: number;
  nuove: number;
  gia_viste: number;
  dal: string;
  al: string;
};

export type Saldi = {
  conti: ContoSaldo[];
  totale: string;
  letti: number;
  /** Somma dei calcolati da noi, solo dei conti senza saldo vero. */
  totale_calcolato: string;
  calcolati: number;
  aggiornamento_in_corso: boolean;
  /** ``null`` finche' non si carica un estratto conto. */
  banca: Banca | null;
  controlli: Controllo[];
};

const ROTTA = "/api/invoicing/saldi";

export function fetchSaldi(signal?: AbortSignal): Promise<Saldi> {
  return apiGet(ROTTA, signal ? { signal } : undefined);
}

export function rileggiSaldi(): Promise<{ accodato: boolean }> {
  return apiPost(`${ROTTA}/rileggi`);
}

export function caricaEstratto(file: File): Promise<EsitoEstratto> {
  const body = new FormData();
  body.append("file", file);
  return apiPostForm(`${ROTTA}/banca`, body);
}
